const TRUST_ITEMS = [
  { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
  { icon: 'ri-medal-2-fill', label: 'GAF Certified' },
  { icon: 'ri-award-fill', label: 'Fortification Certified' },
  { icon: 'ri-file-list-3-fill', label: 'Insurance Claim Help' },
  { icon: 'ri-map-pin-2-fill', label: 'Gulf Coast Local' },
  { icon: 'ri-home-4-fill', label: 'Residential & Commercial' },
];

export default function TrustBar() {
  return (
    <div className="bg-ink relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/8 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-white/6 rounded-lg overflow-hidden border border-white/6">
          {TRUST_ITEMS.map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center gap-2.5 py-5 px-4 bg-ink hover:bg-white/4 transition-colors group"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full border border-gold/25 group-hover:border-gold/50 transition-colors shrink-0">
                <i className={`${item.icon} text-gold text-sm`}></i>
              </div>
              <span className="text-[10px] font-semibold tracking-widest uppercase text-white/45 text-center leading-tight group-hover:text-white/70 transition-colors whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
